<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle2')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle2') }}</h1>
    <span>{{ $t('artText2-1') }}</span>
    <h2>{{ $t('artText2-2') }}</h2>
    <span>{{ $t('artText2-3') }}</span>
    <ol>
      <li>
        {{ $t('artText2-3li-1') }}
      </li>
      <li>
        {{ $t('artText2-3li-2') }}
      </li>
      <li>
        {{ $t('artText2-3li-3') }}
      </li>
      <li>
        {{ $t('artText2-3li-4') }}
      </li>
    </ol>
    <img
      :src="`${staticUrl}/images/DreamFlat-A-Free-and-Comprehensive-Interior-Design-Tool1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText2-4') }}</h2>
    <span>{{ $t('artText2-5') }}</span>
    <h2>{{ $t('artText2-6') }}</h2>
    <span>{{ $t('artText2-7') }}</span>
    <img
      :src="`${staticUrl}/images/DreamFlat-A-Free-and-Comprehensive-Interior-Design-Tool.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText2-8') }}</h2>
    <h2 class="m-0">{{ $t('artText2-9') }}</h2>
    <ul class="mt-0">
      <li>{{ $t('artText2-9-li1') }}</li>
      <li>{{ $t('artText2-9-li2') }}</li>
      <li>{{ $t('artText2-9-li3') }}</li>
      <li>{{ $t('artText2-9-li4') }}</li>
    </ul>
    <h2 class="m-0">{{ $t('artText2-10') }}</h2>
    <ul class="mt-0">
      <li>{{ $t('artText2-10-li1') }}</li>
      <li>{{ $t('artText2-10-li2') }}</li>
    </ul>
    <h2 class="m-0">{{ $t('artText2-11') }}</h2>
    <span>{{ $t('artText2-12') }}</span>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle2')}`,
  ogTitle: `${t('artSeoTitle2')}`,
  description: `${t('artSeoDesc2')}`,
  ogDescription: `${t('artSeoDesc2')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
